(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dede-product-option-layout-backup-20260922"] && !Shopify.designMode) return;
  try {
    (() => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

      const chooseText = marker.dataset.chooseText?.trim();

      if (!chooseText) return;

      const addChooseText = (label) => {
        if (label.dataset.dedeChooseAdded === 'true') return;

        const text = document.createElement('span');
        text.className = 'dede-choose-text';
        text.textContent = chooseText;

        const gpoLabelContent = label.matches('.gpo-label')
          ? label.querySelector('.label-content')
          : null;

        if (gpoLabelContent) {
          gpoLabelContent.insertAdjacentElement('afterend', text);
        } else {
          label.append(text);
        }

        label.dataset.dedeChooseAdded = 'true';
      };

      const enhanceOptions = () => {
        document
          .querySelectorAll(
            'variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label, .gpo-container .gpo-element > .gpo-label'
          )
          .forEach(addChooseText);

        document
          .querySelectorAll('variant-selects .product-form__input--dropdown')
          .forEach((field) => field.classList.add('dede-option-row'));

        document.querySelectorAll('.gpo-container .gpo-element').forEach((field) => {
          if (field.querySelector(':scope > .gpo-select, :scope > .gpo-dropdown, :scope > .gpo-input-wrap')) {
            field.classList.add('dede-gpo-dropdown-row');
          }
        });
      };

      let updateQueued = false;

      const queueEnhancement = () => {
        if (updateQueued) return;

        updateQueued = true;
        requestAnimationFrame(() => {
          updateQueued = false;
          enhanceOptions();
        });
      };

      enhanceOptions();

      const observer = new MutationObserver(queueEnhancement);
      observer.observe(document.body, { childList: true, subtree: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260923-arrow-single-option"] && !Shopify.designMode) return;
  try {
    (() => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

      const configuredChooseText = marker.dataset.chooseText?.trim();
      const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;

      if (!chooseText) return;

      const addChooseText = (label) => {
        if (label.dataset.dedeChooseAdded === 'true') return;

        const text = document.createElement('span');
        text.className = 'dede-choose-text';
        text.textContent = chooseText;

        const gpoLabelContent = label.matches('.gpo-label')
          ? label.querySelector('.label-content')
          : null;

        if (gpoLabelContent) {
          gpoLabelContent.insertAdjacentElement('afterend', text);
        } else {
          label.append(text);
        }

        label.dataset.dedeChooseAdded = 'true';
      };

      const formatGloboAddonPrices = () => {
        document.querySelectorAll('.gpo-app .addOn, .gpo-total-text .money').forEach((element) => {
          const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
          let textNode = walker.nextNode();

          while (textNode) {
            const formatted = textNode.nodeValue.replace(/(\d[\d,]*)\.00(?=\s*(?:TL|TRY)\b)/g, '$1');

            if (formatted !== textNode.nodeValue) {
              textNode.nodeValue = formatted;
            }

            textNode = walker.nextNode();
          }
        });
      };

      const enhanceOptions = () => {
        document
          .querySelectorAll(
            'variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label'
          )
          .forEach(addChooseText);

        document
          .querySelectorAll('variant-selects .product-form__input--dropdown')
          .forEach((field) => field.classList.add('dede-option-row'));

        document.querySelectorAll('.gpo-container .gpo-element').forEach((field) => {
          if (field.querySelector(':scope > .gpo-select, :scope > .gpo-dropdown, :scope > .gpo-input-wrap')) {
            field.classList.add('dede-gpo-dropdown-row');
          }
        });

        formatGloboAddonPrices();
      };

      let updateQueued = false;

      const queueEnhancement = () => {
        if (updateQueued) return;

        updateQueued = true;
        requestAnimationFrame(() => {
          updateQueued = false;
          enhanceOptions();
        });
      };

      enhanceOptions();

      const observer = new MutationObserver(queueEnhancement);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260923-description-profile"] && !Shopify.designMode) return;
  try {
    (() => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

      const configuredChooseText = marker.dataset.chooseText?.trim();
      const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;

      if (!chooseText) return;

      const addChooseText = (label) => {
        if (label.dataset.dedeChooseAdded === 'true') return;

        const text = document.createElement('span');
        text.className = 'dede-choose-text';
        text.textContent = chooseText;

        const gpoLabelContent = label.matches('.gpo-label')
          ? label.querySelector('.label-content')
          : null;

        if (gpoLabelContent) {
          gpoLabelContent.insertAdjacentElement('afterend', text);
        } else {
          label.append(text);
        }

        label.dataset.dedeChooseAdded = 'true';
      };

      const formatGloboAddonPrices = () => {
        document.querySelectorAll('.gpo-app .addOn, .gpo-total-text .money').forEach((element) => {
          const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
          let textNode = walker.nextNode();

          while (textNode) {
            const formatted = textNode.nodeValue.replace(/(\d[\d,]*)\.00(?=\s*(?:TL|TRY)\b)/g, '$1');

            if (formatted !== textNode.nodeValue) {
              textNode.nodeValue = formatted;
            }

            textNode = walker.nextNode();
          }
        });
      };

      const enhanceOptions = () => {
        document
          .querySelectorAll(
            'variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label'
          )
          .forEach(addChooseText);

        document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((field) => {
          const select = field.querySelector(':scope > .select > .select__select');
          const isSingleOption = select?.options.length === 1;

          field.classList.add('dede-option-row');
          field.classList.toggle('dede-single-option', isSingleOption);

          if (!select) return;

          if (isSingleOption) {
            select.setAttribute('aria-disabled', 'true');
            select.tabIndex = -1;
            select.dataset.dedeSingleOption = 'true';
          } else if (select.dataset.dedeSingleOption === 'true') {
            select.removeAttribute('aria-disabled');
            select.removeAttribute('tabindex');
            delete select.dataset.dedeSingleOption;
          }
        });

        document.querySelectorAll('.gpo-container .gpo-element').forEach((field) => {
          if (field.querySelector(':scope > .gpo-select, :scope > .gpo-dropdown, :scope > .gpo-input-wrap')) {
            field.classList.add('dede-gpo-dropdown-row');
          }
        });

        formatGloboAddonPrices();
      };

      let updateQueued = false;

      const queueEnhancement = () => {
        if (updateQueued) return;

        updateQueued = true;
        requestAnimationFrame(() => {
          updateQueued = false;
          enhanceOptions();
        });
      };

      enhanceOptions();

      const observer = new MutationObserver(queueEnhancement);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260923-price-cleanup"] && !Shopify.designMode) return;
  try {
    (() => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

      const configuredChooseText = marker.dataset.chooseText?.trim();
      const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;

      if (!chooseText) return;

      const addChooseText = (label) => {
        const field = label.closest('.product-form__input');
        const select = field?.querySelector(':scope > .select > .select__select');
        const radioCount = field?.querySelectorAll('input[type="radio"]').length ?? 0;
        const optionCount = select?.options.length ?? radioCount;

        if (optionCount === 1) {
          label.querySelector(':scope > .dede-choose-text')?.remove();
          delete label.dataset.dedeChooseAdded;
          return;
        }

        if (label.dataset.dedeChooseAdded === 'true') return;

        const text = document.createElement('span');
        text.className = 'dede-choose-text';
        text.textContent = chooseText;

        const gpoLabelContent = label.matches('.gpo-label')
          ? label.querySelector('.label-content')
          : null;

        if (gpoLabelContent) {
          gpoLabelContent.insertAdjacentElement('afterend', text);
        } else {
          label.append(text);
        }

        label.dataset.dedeChooseAdded = 'true';
      };

      const formatGloboAddonPrices = () => {
        document.querySelectorAll('.gpo-app .addOn, .gpo-total-text .money').forEach((element) => {
          const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
          let textNode = walker.nextNode();

          while (textNode) {
            const formatted = textNode.nodeValue.replace(/(\d[\d,]*)\.00(?=\s*(?:TL|TRY)\b)/g, '$1');

            if (formatted !== textNode.nodeValue) {
              textNode.nodeValue = formatted;
            }

            textNode = walker.nextNode();
          }
        });
      };

      const enhanceOptions = () => {
        document
          .querySelectorAll(
            'variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label'
          )
          .forEach(addChooseText);

        document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((field) => {
          const select = field.querySelector(':scope > .select > .select__select');
          const isSingleOption = select?.options.length === 1;

          field.classList.add('dede-option-row');
          field.classList.toggle('dede-single-option', isSingleOption);

          if (!select) return;

          if (isSingleOption) {
            select.setAttribute('aria-disabled', 'true');
            select.tabIndex = -1;
            select.dataset.dedeSingleOption = 'true';
          } else if (select.dataset.dedeSingleOption === 'true') {
            select.removeAttribute('aria-disabled');
            select.removeAttribute('tabindex');
            delete select.dataset.dedeSingleOption;
          }
        });

        document.querySelectorAll('.gpo-container .gpo-element').forEach((field) => {
          if (field.querySelector(':scope > .gpo-select, :scope > .gpo-dropdown, :scope > .gpo-input-wrap')) {
            field.classList.add('dede-gpo-dropdown-row');
          }

          const labelText = field.querySelector(':scope > .gpo-label .label-content')?.textContent.trim() ?? '';
          const hasImageSwatches = field.querySelector(':scope > .gpo-ov-wrapper .image-swatches');

          field.classList.toggle(
            'dede-gpo-profile-row',
            Boolean(hasImageSwatches && labelText.includes('Profil Rengi'))
          );
        });

        formatGloboAddonPrices();
      };

      let updateQueued = false;

      const queueEnhancement = () => {
        if (updateQueued) return;

        updateQueued = true;
        requestAnimationFrame(() => {
          updateQueued = false;
          enhanceOptions();
        });
      };

      enhanceOptions();

      const observer = new MutationObserver(queueEnhancement);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260923"] && !Shopify.designMode) return;
  try {
    (() => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

      const chooseText = marker.dataset.chooseText?.trim();

      if (!chooseText) return;

      const addChooseText = (label) => {
        if (label.dataset.dedeChooseAdded === 'true') return;

        const text = document.createElement('span');
        text.className = 'dede-choose-text';
        text.textContent = chooseText;

        const gpoLabelContent = label.matches('.gpo-label')
          ? label.querySelector('.label-content')
          : null;

        if (gpoLabelContent) {
          gpoLabelContent.insertAdjacentElement('afterend', text);
        } else {
          label.append(text);
        }

        label.dataset.dedeChooseAdded = 'true';
      };

      const formatGloboAddonPrices = () => {
        document.querySelectorAll('.gpo-app .addOn, .gpo-total-text .money').forEach((element) => {
          const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
          let textNode = walker.nextNode();

          while (textNode) {
            const formatted = textNode.nodeValue.replace(/(\d[\d,]*)\.00(?=\s*(?:TL|TRY)\b)/g, '$1');

            if (formatted !== textNode.nodeValue) {
              textNode.nodeValue = formatted;
            }

            textNode = walker.nextNode();
          }
        });
      };

      const enhanceOptions = () => {
        document
          .querySelectorAll(
            'variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label, .gpo-container .gpo-element > .gpo-label'
          )
          .forEach(addChooseText);

        document
          .querySelectorAll('variant-selects .product-form__input--dropdown')
          .forEach((field) => field.classList.add('dede-option-row'));

        document.querySelectorAll('.gpo-container .gpo-element').forEach((field) => {
          if (field.querySelector(':scope > .gpo-select, :scope > .gpo-dropdown, :scope > .gpo-input-wrap')) {
            field.classList.add('dede-gpo-dropdown-row');
          }
        });

        formatGloboAddonPrices();
      };

      let updateQueued = false;

      const queueEnhancement = () => {
        if (updateQueued) return;

        updateQueued = true;
        requestAnimationFrame(() => {
          updateQueued = false;
          enhanceOptions();
        });
      };

      enhanceOptions();

      const observer = new MutationObserver(queueEnhancement);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260924-pre-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

      const configuredChooseText = marker.dataset.chooseText?.trim();
      const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;

      if (!chooseText) return;

      const addChooseText = (label) => {
        const field = label.closest('.product-form__input');
        const select = field?.querySelector(':scope > .select > .select__select');
        const radioCount = field?.querySelectorAll('input[type="radio"]').length ?? 0;
        const optionCount = select?.options.length ?? radioCount;

        if (optionCount === 1) {
          label.querySelector(':scope > .dede-choose-text')?.remove();
          delete label.dataset.dedeChooseAdded;
          return;
        }

        if (label.dataset.dedeChooseAdded === 'true') return;

        const text = document.createElement('span');
        text.className = 'dede-choose-text';
        text.textContent = chooseText;

        const gpoLabelContent = label.matches('.gpo-label')
          ? label.querySelector('.label-content')
          : null;

        if (gpoLabelContent) {
          gpoLabelContent.insertAdjacentElement('afterend', text);
        } else {
          label.append(text);
        }

        label.dataset.dedeChooseAdded = 'true';
      };

      const formatGloboAddonPrices = () => {
        document
          .querySelectorAll('.gpo-app .addOn, .gpo-total-text .money, .gpo-container .gpo-select option')
          .forEach((element) => {
            const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
            let textNode = walker.nextNode();

            while (textNode) {
              const formatted = textNode.nodeValue.replace(/(\d[\d,]*)\.00(?=\s*(?:TL|TRY)\b)/g, '$1');

              if (formatted !== textNode.nodeValue) {
                textNode.nodeValue = formatted;
              }

              textNode = walker.nextNode();
            }
          });
      };

      const enhanceOptions = () => {
        document
          .querySelectorAll(
            'variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label'
          )
          .forEach(addChooseText);

        document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((field) => {
          const select = field.querySelector(':scope > .select > .select__select');
          const isSingleOption = select?.options.length === 1;

          field.classList.add('dede-option-row');
          field.classList.toggle('dede-single-option', isSingleOption);

          if (!select) return;

          if (isSingleOption) {
            select.setAttribute('aria-disabled', 'true');
            select.tabIndex = -1;
            select.dataset.dedeSingleOption = 'true';
          } else if (select.dataset.dedeSingleOption === 'true') {
            select.removeAttribute('aria-disabled');
            select.removeAttribute('tabindex');
            delete select.dataset.dedeSingleOption;
          }
        });

        document.querySelectorAll('.gpo-container .gpo-element').forEach((field) => {
          if (field.querySelector(':scope > .gpo-select, :scope > .gpo-dropdown, :scope > .gpo-input-wrap')) {
            field.classList.add('dede-gpo-dropdown-row');
          }

          const labelText = field.querySelector(':scope > .gpo-label .label-content')?.textContent.trim() ?? '';
          const hasImageSwatches = field.querySelector(':scope > .gpo-ov-wrapper .image-swatches');

          field.classList.toggle(
            'dede-gpo-profile-row',
            Boolean(hasImageSwatches && labelText.includes('Profil Rengi'))
          );
        });

        formatGloboAddonPrices();
      };

      let updateQueued = false;

      const queueEnhancement = () => {
        if (updateQueued) return;

        updateQueued = true;
        requestAnimationFrame(() => {
          updateQueued = false;
          enhanceOptions();
        });
      };

      enhanceOptions();

      const observer = new MutationObserver(queueEnhancement);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260924-pre-strict-help"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

    const configuredChooseText = marker.dataset.chooseText?.trim();
    const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;
    const optionsTitle = marker.dataset.optionsTitle?.trim() || 'Ürün Seçenekleri';
    const optionsSubtitle = marker.dataset.optionsSubtitle?.trim() || 'Standart seçenekleri özelleştirin';
    const includedText = marker.dataset.includedText?.trim() || 'Fiyata Dahil';
    const extraTotalText = marker.dataset.extraTotalText?.trim() || 'Seçeneklerden eklenen tutar:';
    const moneyFormatter = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });

    const normalizeWhitespace = (value) => value.replace(/\s+/g, ' ').trim();

    const addChooseText = (label) => {
      if (!chooseText) return;

      const field = label.closest('.product-form__input');
      const select = field?.querySelector(':scope > .select > .select__select');
      const radioCount = field?.querySelectorAll('input[type="radio"]').length ?? 0;
      const optionCount = select?.options.length ?? radioCount;

      if (optionCount === 1) {
        label.querySelector(':scope > .dede-choose-text')?.remove();
        delete label.dataset.dedeChooseAdded;
        return;
      }

      if (label.dataset.dedeChooseAdded === 'true') return;

      const text = document.createElement('span');
      text.className = 'dede-choose-text';
      text.textContent = chooseText;

      const gpoLabelContent = label.matches('.gpo-label')
        ? label.querySelector('.label-content')
        : null;

      if (gpoLabelContent) {
        gpoLabelContent.insertAdjacentElement('afterend', text);
      } else {
        label.append(text);
      }

      label.dataset.dedeChooseAdded = 'true';
    };

    const formatMoney = (value) => `${moneyFormatter.format(value)} TL`;

    const normalizeOptionName = (fieldLabel, value) => {
      let name = normalizeWhitespace(value)
        .replace(/\s*[—-]\s*Fiyata\s+dahil\s*$/i, '')
        .replace(/\s*\(\s*\+[^)]*\)\s*$/i, '');

      if (fieldLabel === 'Kabin Sistemi' && name === 'Eko Sistem') {
        name = 'Standart Duş Sistemi';
      }

      if (fieldLabel === 'Duş Armatür Seti' && name === 'Standart') {
        name = 'Standart Duş Seti';
      }

      if (fieldLabel === 'Duş Armatür Seti' && name === 'GROHE') {
        name = 'GROHE Duş Seti';
      }

      return name;
    };

    const getOptionPrice = (option) => {
      const value = Number.parseFloat(option.dataset.addonPrice || '0');
      return Number.isFinite(value) ? value : 0;
    };

    const updateSelectDisplay = (field) => {
      const selectWrap = field.querySelector(':scope > .gpo-select');
      const select = selectWrap?.querySelector('select');
      const fieldLabel = field.querySelector('.gpo-label .label-content')?.textContent.trim() || '';

      if (!selectWrap || !select) return;

      Array.from(select.options).forEach((option) => {
        if (!option.value) {
          option.dataset.dedeShortLabel = normalizeWhitespace(option.textContent);
          return;
        }

        const sourceName = option.getAttribute('original-value') || option.value || option.textContent;
        const shortName = normalizeOptionName(fieldLabel, sourceName);
        const price = getOptionPrice(option);
        const fullLabel = price > 0
          ? `${shortName} — +${formatMoney(price)}`
          : `${shortName} — ${includedText}`;

        option.dataset.dedeShortLabel = shortName;

        if (normalizeWhitespace(option.textContent) !== fullLabel) {
          option.textContent = fullLabel;
        }
      });

      let display = selectWrap.querySelector(':scope > .dede-select-display');

      if (!display) {
        display = document.createElement('span');
        display.className = 'dede-select-display';
        display.setAttribute('aria-hidden', 'true');
        selectWrap.append(display);
      }

      const refreshDisplay = () => {
        const selectedOption = select.options[select.selectedIndex];
        const shortLabel = selectedOption?.dataset.dedeShortLabel || normalizeWhitespace(selectedOption?.textContent || '');

        if (display.textContent !== shortLabel) {
          display.textContent = shortLabel;
        }
      };

      select.classList.add('dede-select-overlay-active');
      refreshDisplay();

      if (select.dataset.dedeDisplayBound !== 'true') {
        select.addEventListener('change', refreshDisplay);
        select.dataset.dedeDisplayBound = 'true';
      }
    };

    const hasChoiceLabel = (element) => {
      const label = element.querySelector(':scope > .gpo-label .label-content, :scope > .dede-label-group .gpo-label .label-content');
      return Boolean(label);
    };

    const getChoiceLabel = (field) => field
      .querySelector('.gpo-label .label-content')
      ?.textContent.trim() || '';

    const getHelpSources = (field, body) => {
      const children = Array.from(body.children);
      const startIndex = children.indexOf(field);
      const sources = [];

      for (let index = startIndex + 1; index < children.length; index += 1) {
        const candidate = children[index];

        if (hasChoiceLabel(candidate)) break;

        if (candidate.querySelector(':scope > .gpo-paragraph.gpo-tinymce')) {
          sources.push(candidate);
        }
      }

      return sources;
    };

    const getHelpText = (source) => {
      const content = source.querySelector(':scope > .gpo-paragraph.gpo-tinymce') || source;
      const clone = content.cloneNode(true);

      clone.querySelectorAll('br').forEach((breakElement) => {
        breakElement.replaceWith(document.createTextNode('\n'));
      });

      clone.querySelectorAll('p, li, div').forEach((block) => {
        block.append(document.createTextNode('\n'));
      });

      return clone.textContent
        .replace(/\u00a0/g, ' ')
        .replace(/[\t ]+/g, ' ')
        .replace(/ *\n */g, '\n')
        .trim();
    };

    const splitHelpText = (value) => value
      .replace(/\[\[AYIR\]\]/g, '\n')
      .replace(/([.!?])\s+(?=\S)/g, '$1\n')
      .split(/\n+/)
      .map((part) => part.trim())
      .filter(Boolean);

    const appendHelpParagraph = (block, text) => {
      const paragraph = document.createElement('p');
      const colonIndex = text.indexOf(':');

      if (colonIndex > 0 && colonIndex <= 80) {
        const heading = document.createElement('strong');
        heading.textContent = text.slice(0, colonIndex + 1);
        paragraph.append(heading, document.createTextNode(text.slice(colonIndex + 1)));
      } else {
        paragraph.textContent = text;
      }

      block.append(paragraph);
    };

    const renderHelpPanel = (panel, sources, tooltipText) => {
      const signature = [tooltipText, ...sources.map((source) => source.innerHTML)].join('|');

      if (panel.dedeHelpSignature === signature) return;

      panel.replaceChildren();

      sources.forEach((source) => {
        const parts = splitHelpText(getHelpText(source));
        const block = document.createElement('div');
        block.className = 'dede-info-block';

        parts.forEach((part) => appendHelpParagraph(block, part));

        if (parts.length > 0) panel.append(block);
      });

      if (tooltipText && sources.length === 0) {
        const block = document.createElement('div');
        block.className = 'dede-info-block';
        splitHelpText(tooltipText).forEach((part) => appendHelpParagraph(block, part));
        panel.append(block);
      }

      panel.dedeHelpSignature = signature;
    };

    const closeOtherInfoPanels = (group, activeButton) => {
      group.querySelectorAll('.dede-info-button').forEach((button) => {
        if (button === activeButton) return;

        button.setAttribute('aria-expanded', 'false');
        const panel = group.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);

        if (panel) panel.hidden = true;
      });
    };

    const enhanceInfoField = (field, body, group, optionSetId) => {
      const fieldLabel = getChoiceLabel(field);

      const label = field.querySelector(':scope > .gpo-label, :scope > .dede-label-group > .gpo-label');

      if (!label) return;

      const sources = getHelpSources(field, body);
      const originalTooltip = label.querySelector('.label-tooltip');
      const tooltipText = originalTooltip
        ?.querySelector('.label-tooltip__content')
        ?.textContent.trim() || '';

      sources.forEach((source) => {
        source.hidden = true;
        source.setAttribute('aria-hidden', 'true');
        source.classList.add('dede-help-source');
      });

      if (originalTooltip) {
        originalTooltip.classList.add('dede-original-tooltip');
        originalTooltip.setAttribute('aria-hidden', 'true');
      }

      let labelGroup = field.querySelector(':scope > .dede-label-group');

      if (!labelGroup) {
        labelGroup = document.createElement('div');
        labelGroup.className = 'dede-label-group';
        label.before(labelGroup);
        labelGroup.append(label);
      }

      const hasHelp = sources.length > 0 || Boolean(tooltipText);
      let infoButton = labelGroup.querySelector(':scope > .dede-info-button');
      let panel = field.querySelector(':scope > .dede-info-panel');

      if (hasHelp && !panel) {
        panel = document.createElement('div');
        panel.className = 'dede-info-panel';
        panel.id = `dede-info-${optionSetId}-${field.dataset.elementId || fieldLabel}`.replace(/[^a-zA-Z0-9_-]/g, '-');
        panel.hidden = true;
        field.append(panel);
      }

      if (hasHelp && !infoButton) {
        infoButton = document.createElement('button');
        infoButton.type = 'button';
        infoButton.className = 'dede-info-button';
        infoButton.textContent = 'ⓘ';
        infoButton.setAttribute('aria-label', `${fieldLabel} hakkında bilgi`);
        infoButton.setAttribute('aria-expanded', 'false');
        infoButton.setAttribute('aria-controls', panel.id);
        labelGroup.append(infoButton);

        infoButton.addEventListener('click', () => {
          const willOpen = infoButton.getAttribute('aria-expanded') !== 'true';
          closeOtherInfoPanels(group, infoButton);
          infoButton.setAttribute('aria-expanded', String(willOpen));
          panel.hidden = !willOpen;
        });
      }

      if (panel) {
        renderHelpPanel(panel, sources, tooltipText);
      }

      field.classList.add('dede-gpo-choice-row');
      updateSelectDisplay(field);
    };

    const getSelectedAddonTotal = (app) => {
      let total = 0;

      app.querySelectorAll('select').forEach((select) => {
        const option = select.options[select.selectedIndex];
        total += option ? getOptionPrice(option) : 0;
      });

      app.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach((input) => {
        const value = Number.parseFloat(input.dataset.addonPrice || '0');
        total += Number.isFinite(value) ? value : 0;
      });

      return total;
    };

    const updateTotalSummary = (app) => {
      const totalContainer = app.querySelector(':scope > .gpo-total');
      const source = totalContainer?.querySelector('.gpo-total-text');

      if (!totalContainer || !source) return;

      source.classList.add('dede-total-source');

      let summary = totalContainer.querySelector(':scope > .dede-total-summary');

      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'dede-total-summary';
        summary.setAttribute('aria-live', 'polite');

        const label = document.createElement('span');
        label.textContent = extraTotalText;

        const value = document.createElement('strong');
        value.className = 'dede-total-value';

        summary.append(label, value);
        totalContainer.append(summary);
      }

      const total = getSelectedAddonTotal(app);
      const formatted = total > 0 ? `+${formatMoney(total)}` : '';
      const value = summary.querySelector('.dede-total-value');

      if (value.textContent !== formatted) value.textContent = formatted;

      summary.hidden = total <= 0;
      totalContainer.classList.toggle('dede-total-empty', total <= 0);
    };

    const openOptionsGroup = (group) => {
      const toggle = group.querySelector(':scope > .dede-options-toggle');
      const body = group.querySelector('.dede-options-body');

      if (!toggle || !body) return;

      toggle.setAttribute('aria-expanded', 'true');
      body.hidden = false;
    };

    const revealValidationErrors = (group) => {
      const body = group.querySelector('.dede-options-body');

      if (!body) return;

      const error = Array.from(body.querySelectorAll('.messages')).find((message) => message.textContent.trim());

      if (!error) {
        delete group.dataset.dedeErrorRevealed;
        return;
      }

      openOptionsGroup(group);

      if (group.dataset.dedeErrorRevealed === 'true') return;

      group.dataset.dedeErrorRevealed = 'true';
      const field = error.closest('.gpo-element');
      const control = field?.querySelector('select, input, textarea');

      field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      control?.focus({ preventScroll: true });
    };

    const enhanceGloboGroup = (group, app, groupIndex) => {
      const body = group.querySelector('.gpo-group__childs');

      if (!body) return;

      const choiceFields = Array.from(body.children).filter(hasChoiceLabel);

      if (choiceFields.length === 0) return;

      group.classList.add('dede-options-group');
      body.classList.add('dede-options-body');

      if (!body.id) {
        body.id = `dede-options-body-${app.dataset.optionSetId || 'product'}-${groupIndex}`;
      }

      let toggle = group.querySelector(':scope > .dede-options-toggle');

      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'dede-options-toggle';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-controls', body.id);

        const title = document.createElement('span');
        title.className = 'dede-options-title';
        title.textContent = optionsTitle;

        const subtitle = document.createElement('span');
        subtitle.className = 'dede-options-subtitle';
        subtitle.textContent = optionsSubtitle;

        const chevron = document.createElement('span');
        chevron.className = 'dede-options-chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '⌄';

        toggle.append(title, subtitle, chevron);
        const toggleAnchor = body.closest('.gpo-group__wrapper') || body;
        group.insertBefore(toggle, toggleAnchor);

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isOpen));
          body.hidden = isOpen;
        });
      }

      const optionSetId = `${app.dataset.optionSetId || 'product'}-${groupIndex}`;
      choiceFields.forEach((field) => enhanceInfoField(field, body, group, optionSetId));
      revealValidationErrors(group);
    };

    const enhanceOptions = () => {
      document
        .querySelectorAll('variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label')
        .forEach(addChooseText);

      document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((field) => {
        const select = field.querySelector(':scope > .select > .select__select');
        const isSingleOption = select?.options.length === 1;

        field.classList.add('dede-option-row');
        field.classList.toggle('dede-single-option', isSingleOption);

        if (!select) return;

        if (isSingleOption) {
          select.setAttribute('aria-disabled', 'true');
          select.tabIndex = -1;
          select.dataset.dedeSingleOption = 'true';
        } else if (select.dataset.dedeSingleOption === 'true') {
          select.removeAttribute('aria-disabled');
          select.removeAttribute('tabindex');
          delete select.dataset.dedeSingleOption;
        }
      });

      document.querySelectorAll('.gpo-container .gpo-app').forEach((app) => {
        app.querySelectorAll(':scope > .gpo-group').forEach((group, groupIndex) => {
          enhanceGloboGroup(group, app, groupIndex);
        });

        updateTotalSummary(app);

        if (app.dataset.dedeChangeBound !== 'true') {
          app.addEventListener('change', queueEnhancement);
          app.dataset.dedeChangeBound = 'true';
        }
      });

    };

    let updateQueued = false;

    const queueEnhancement = () => {
      if (updateQueued) return;

      updateQueued = true;
      requestAnimationFrame(() => {
        updateQueued = false;
        enhanceOptions();
      });
    };

    enhanceOptions();

    const observer = new MutationObserver(queueEnhancement);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260924-pre-universal-globo"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

    const configuredChooseText = marker.dataset.chooseText?.trim();
    const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;
    const optionsTitle = marker.dataset.optionsTitle?.trim() || 'Ürün Seçenekleri';
    const includedText = marker.dataset.includedText?.trim() || 'Fiyata Dahil';
    const extraTotalText = marker.dataset.extraTotalText?.trim() || 'Ek seçenekler toplamı';
    const optionLabels = new Set([
      'Kabin Sistemi',
      'Duş Armatür Seti',
      'Profil Rengi',
      'Küvet Sistemi',
      'Nakliye/Montaj'
    ]);
    const moneyFormatter = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });

    const normalizeWhitespace = (value) => value.replace(/\s+/g, ' ').trim();

    const addChooseText = (label) => {
      if (!chooseText) return;

      const field = label.closest('.product-form__input');
      const select = field?.querySelector(':scope > .select > .select__select');
      const radioCount = field?.querySelectorAll('input[type="radio"]').length ?? 0;
      const optionCount = select?.options.length ?? radioCount;

      if (optionCount === 1) {
        label.querySelector(':scope > .dede-choose-text')?.remove();
        delete label.dataset.dedeChooseAdded;
        return;
      }

      if (label.dataset.dedeChooseAdded === 'true') return;

      const text = document.createElement('span');
      text.className = 'dede-choose-text';
      text.textContent = chooseText;

      const gpoLabelContent = label.matches('.gpo-label')
        ? label.querySelector('.label-content')
        : null;

      if (gpoLabelContent) {
        gpoLabelContent.insertAdjacentElement('afterend', text);
      } else {
        label.append(text);
      }

      label.dataset.dedeChooseAdded = 'true';
    };

    const formatMoney = (value) => `${moneyFormatter.format(value)} TL`;

    const normalizeOptionName = (fieldLabel, value) => {
      let name = normalizeWhitespace(value)
        .replace(/\s*[—-]\s*Fiyata\s+dahil\s*$/i, '')
        .replace(/\s*\(\s*\+[^)]*\)\s*$/i, '');

      if (fieldLabel === 'Kabin Sistemi' && name === 'Eko Sistem') {
        name = 'Standart Duş Sistemi';
      }

      if (fieldLabel === 'Duş Armatür Seti' && name === 'Standart') {
        name = 'Standart Duş Seti';
      }

      if (fieldLabel === 'Duş Armatür Seti' && name === 'GROHE') {
        name = 'GROHE Duş Seti';
      }

      return name;
    };

    const getOptionPrice = (option) => {
      const value = Number.parseFloat(option.dataset.addonPrice || '0');
      return Number.isFinite(value) ? value : 0;
    };

    const updateSelectDisplay = (field) => {
      const selectWrap = field.querySelector(':scope > .gpo-select');
      const select = selectWrap?.querySelector('select');
      const fieldLabel = field.querySelector('.gpo-label .label-content')?.textContent.trim() || '';

      if (!selectWrap || !select) return;

      Array.from(select.options).forEach((option) => {
        if (!option.value) {
          option.dataset.dedeShortLabel = normalizeWhitespace(option.textContent);
          return;
        }

        const sourceName = option.getAttribute('original-value') || option.value || option.textContent;
        const shortName = normalizeOptionName(fieldLabel, sourceName);
        const price = getOptionPrice(option);
        const fullLabel = price > 0
          ? `${shortName} — +${formatMoney(price)}`
          : `${shortName} — ${includedText}`;

        option.dataset.dedeShortLabel = shortName;

        if (normalizeWhitespace(option.textContent) !== fullLabel) {
          option.textContent = fullLabel;
        }
      });

      let display = selectWrap.querySelector(':scope > .dede-select-display');

      if (!display) {
        display = document.createElement('span');
        display.className = 'dede-select-display';
        display.setAttribute('aria-hidden', 'true');
        selectWrap.append(display);
      }

      const refreshDisplay = () => {
        const selectedOption = select.options[select.selectedIndex];
        const shortLabel = selectedOption?.dataset.dedeShortLabel || normalizeWhitespace(selectedOption?.textContent || '');

        if (display.textContent !== shortLabel) {
          display.textContent = shortLabel;
        }
      };

      select.classList.add('dede-select-overlay-active');
      refreshDisplay();

      if (select.dataset.dedeDisplayBound !== 'true') {
        select.addEventListener('change', refreshDisplay);
        select.dataset.dedeDisplayBound = 'true';
      }
    };

    const hasChoiceLabel = (element) => {
      const label = element.querySelector(':scope > .gpo-label .label-content, :scope > .dede-label-group .gpo-label .label-content');
      return Boolean(label);
    };

    const getChoiceLabel = (field) => field
      .querySelector('.gpo-label .label-content')
      ?.textContent.trim() || '';

    const getHelpSources = (field, body) => {
      const children = Array.from(body.children);
      const startIndex = children.indexOf(field);
      const sources = [];

      for (let index = startIndex + 1; index < children.length; index += 1) {
        const candidate = children[index];

        if (hasChoiceLabel(candidate)) break;

        if (candidate.querySelector(':scope > .gpo-paragraph.gpo-tinymce')) {
          sources.push(candidate);
        }
      }

      return sources;
    };

    const cleanHelpClone = (source) => {
      const content = source.querySelector(':scope > .gpo-paragraph.gpo-tinymce') || source;
      const clone = content.cloneNode(true);
      clone.removeAttribute('id');
      clone.removeAttribute('style');
      clone.querySelectorAll('[id], [style]').forEach((element) => {
        element.removeAttribute('id');
        element.removeAttribute('style');
      });

      const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        textNode.nodeValue = textNode.nodeValue.replace(/Eko Sistem/g, 'Standart Duş Sistemi');
        textNode = walker.nextNode();
      }

      return clone;
    };

    const renderHelpPanel = (panel, sources, tooltipText) => {
      const signature = [tooltipText, ...sources.map((source) => source.innerHTML)].join('|');

      if (panel.dedeHelpSignature === signature) return;

      panel.replaceChildren();

      sources.forEach((source) => {
        const clone = cleanHelpClone(source);
        const block = document.createElement('div');
        block.className = 'dede-info-block';

        if (clone.textContent.includes('[[AYIR]]')) {
          clone.textContent
            .split('[[AYIR]]')
            .map((part) => part.trim())
            .filter(Boolean)
            .forEach((part) => {
              const paragraph = document.createElement('p');
              paragraph.textContent = part;
              block.append(paragraph);
            });
        } else {
          while (clone.firstChild) {
            block.append(clone.firstChild);
          }
        }

        panel.append(block);
      });

      if (tooltipText && sources.length === 0) {
        const paragraph = document.createElement('p');
        paragraph.textContent = tooltipText;
        panel.append(paragraph);
      }

      panel.dedeHelpSignature = signature;
    };

    const closeOtherInfoPanels = (group, activeButton) => {
      group.querySelectorAll('.dede-info-button').forEach((button) => {
        if (button === activeButton) return;

        button.setAttribute('aria-expanded', 'false');
        const panel = group.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);

        if (panel) panel.hidden = true;
      });
    };

    const enhanceInfoField = (field, body, group, optionSetId) => {
      const fieldLabel = getChoiceLabel(field);

      if (!optionLabels.has(fieldLabel)) return;

      const label = field.querySelector(':scope > .gpo-label, :scope > .dede-label-group > .gpo-label');

      if (!label) return;

      const sources = getHelpSources(field, body);
      const originalTooltip = label.querySelector('.label-tooltip');
      const tooltipText = originalTooltip
        ?.querySelector('.label-tooltip__content')
        ?.textContent.trim() || '';

      sources.forEach((source) => {
        source.hidden = true;
        source.setAttribute('aria-hidden', 'true');
        source.classList.add('dede-help-source');
      });

      if (originalTooltip) {
        originalTooltip.classList.add('dede-original-tooltip');
        originalTooltip.setAttribute('aria-hidden', 'true');
      }

      let labelGroup = field.querySelector(':scope > .dede-label-group');

      if (!labelGroup) {
        labelGroup = document.createElement('div');
        labelGroup.className = 'dede-label-group';
        label.before(labelGroup);
        labelGroup.append(label);
      }

      const hasHelp = sources.length > 0 || Boolean(tooltipText);
      let infoButton = labelGroup.querySelector(':scope > .dede-info-button');
      let panel = field.querySelector(':scope > .dede-info-panel');

      if (hasHelp && !panel) {
        panel = document.createElement('div');
        panel.className = 'dede-info-panel';
        panel.id = `dede-info-${optionSetId}-${field.dataset.elementId || fieldLabel}`.replace(/[^a-zA-Z0-9_-]/g, '-');
        panel.hidden = true;
        field.append(panel);
      }

      if (hasHelp && !infoButton) {
        infoButton = document.createElement('button');
        infoButton.type = 'button';
        infoButton.className = 'dede-info-button';
        infoButton.textContent = 'ⓘ';
        infoButton.setAttribute('aria-label', `${fieldLabel} hakkında bilgi`);
        infoButton.setAttribute('aria-expanded', 'false');
        infoButton.setAttribute('aria-controls', panel.id);
        labelGroup.append(infoButton);

        infoButton.addEventListener('click', () => {
          const willOpen = infoButton.getAttribute('aria-expanded') !== 'true';
          closeOtherInfoPanels(group, infoButton);
          infoButton.setAttribute('aria-expanded', String(willOpen));
          panel.hidden = !willOpen;
        });
      }

      if (panel) {
        renderHelpPanel(panel, sources, tooltipText);
      }

      field.classList.add('dede-gpo-choice-row');
      updateSelectDisplay(field);
    };

    const getSelectedAddonTotal = (app) => {
      let total = 0;

      app.querySelectorAll('select').forEach((select) => {
        const option = select.options[select.selectedIndex];
        total += option ? getOptionPrice(option) : 0;
      });

      app.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach((input) => {
        const value = Number.parseFloat(input.dataset.addonPrice || '0');
        total += Number.isFinite(value) ? value : 0;
      });

      return total;
    };

    const updateTotalSummary = (app, group) => {
      const totalContainer = app.querySelector(':scope > .gpo-total');
      const source = totalContainer?.querySelector('.gpo-total-text');

      if (!totalContainer || !source) return;

      source.classList.add('dede-total-source');

      let summary = totalContainer.querySelector(':scope > .dede-total-summary');

      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'dede-total-summary';
        summary.setAttribute('aria-live', 'polite');

        const label = document.createElement('span');
        label.textContent = extraTotalText;

        const value = document.createElement('strong');
        value.className = 'dede-total-value';

        summary.append(label, value);
        totalContainer.append(summary);
      }

      const total = getSelectedAddonTotal(app);
      const formatted = total > 0 ? `+${formatMoney(total)}` : '';
      const value = summary.querySelector('.dede-total-value');
      const badge = group.querySelector(':scope > .dede-options-toggle .dede-options-total-badge');

      if (value.textContent !== formatted) value.textContent = formatted;
      if (badge && badge.textContent !== formatted) badge.textContent = formatted;

      summary.hidden = total <= 0;
      totalContainer.classList.toggle('dede-total-empty', total <= 0);

      if (badge) badge.hidden = total <= 0;
    };

    const openOptionsGroup = (group) => {
      const toggle = group.querySelector(':scope > .dede-options-toggle');
      const body = group.querySelector('.dede-options-body');

      if (!toggle || !body) return;

      toggle.setAttribute('aria-expanded', 'true');
      body.hidden = false;
    };

    const revealValidationErrors = (group) => {
      const body = group.querySelector('.dede-options-body');

      if (!body) return;

      const error = Array.from(body.querySelectorAll('.messages')).find((message) => message.textContent.trim());

      if (!error) {
        delete group.dataset.dedeErrorRevealed;
        return;
      }

      openOptionsGroup(group);

      if (group.dataset.dedeErrorRevealed === 'true') return;

      group.dataset.dedeErrorRevealed = 'true';
      const field = error.closest('.gpo-element');
      const control = field?.querySelector('select, input, textarea');

      field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      control?.focus({ preventScroll: true });
    };

    const enhanceGloboGroup = (group, app) => {
      const body = group.querySelector('.gpo-group__childs');

      if (!body) return;

      const choiceFields = Array.from(body.children).filter((field) => optionLabels.has(getChoiceLabel(field)));

      if (choiceFields.length === 0) return;

      group.classList.add('dede-options-group');
      body.classList.add('dede-options-body');

      if (!body.id) {
        body.id = `dede-options-body-${app.dataset.optionSetId || 'product'}`;
      }

      let toggle = group.querySelector(':scope > .dede-options-toggle');

      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'dede-options-toggle';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-controls', body.id);

        const title = document.createElement('span');
        title.textContent = optionsTitle;

        const badge = document.createElement('span');
        badge.className = 'dede-options-total-badge';
        badge.hidden = true;

        const chevron = document.createElement('span');
        chevron.className = 'dede-options-chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '⌄';

        toggle.append(title, badge, chevron);
        const toggleAnchor = body.closest('.gpo-group__wrapper') || body;
        group.insertBefore(toggle, toggleAnchor);

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isOpen));
          body.hidden = isOpen;
        });
      }

      const optionSetId = app.dataset.optionSetId || 'product';
      choiceFields.forEach((field) => enhanceInfoField(field, body, group, optionSetId));
      updateTotalSummary(app, group);
      revealValidationErrors(group);
    };

    const enhanceOptions = () => {
      document
        .querySelectorAll('variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label')
        .forEach(addChooseText);

      document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((field) => {
        const select = field.querySelector(':scope > .select > .select__select');
        const isSingleOption = select?.options.length === 1;

        field.classList.add('dede-option-row');
        field.classList.toggle('dede-single-option', isSingleOption);

        if (!select) return;

        if (isSingleOption) {
          select.setAttribute('aria-disabled', 'true');
          select.tabIndex = -1;
          select.dataset.dedeSingleOption = 'true';
        } else if (select.dataset.dedeSingleOption === 'true') {
          select.removeAttribute('aria-disabled');
          select.removeAttribute('tabindex');
          delete select.dataset.dedeSingleOption;
        }
      });

      document.querySelectorAll('.gpo-container .gpo-app').forEach((app) => {
        app.querySelectorAll(':scope > .gpo-group').forEach((group) => enhanceGloboGroup(group, app));

        if (app.dataset.dedeChangeBound !== 'true') {
          app.addEventListener('change', queueEnhancement);
          app.dataset.dedeChangeBound = 'true';
        }
      });

    };

    let updateQueued = false;

    const queueEnhancement = () => {
      if (updateQueued) return;

      updateQueued = true;
      requestAnimationFrame(() => {
        updateQueued = false;
        enhanceOptions();
      });
    };

    enhanceOptions();

    const observer = new MutationObserver(queueEnhancement);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout-backup-20260924-pre-verbatim-labels"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

    const configuredChooseText = marker.dataset.chooseText?.trim();
    const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;
    const optionsTitle = marker.dataset.optionsTitle?.trim() || 'Ürün Seçenekleri';
    const optionsSubtitle = marker.dataset.optionsSubtitle?.trim() || 'Standart seçenekleri özelleştirin';
    const includedText = marker.dataset.includedText?.trim() || 'Fiyata Dahil';
    const extraTotalText = marker.dataset.extraTotalText?.trim() || 'Seçeneklerden eklenen tutar:';
    const moneyFormatter = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });

    const normalizeWhitespace = (value) => value.replace(/\s+/g, ' ').trim();

    const addChooseText = (label) => {
      if (!chooseText) return;

      const field = label.closest('.product-form__input');
      const select = field?.querySelector(':scope > .select > .select__select');
      const radioCount = field?.querySelectorAll('input[type="radio"]').length ?? 0;
      const optionCount = select?.options.length ?? radioCount;

      if (optionCount === 1) {
        label.querySelector(':scope > .dede-choose-text')?.remove();
        delete label.dataset.dedeChooseAdded;
        return;
      }

      if (label.dataset.dedeChooseAdded === 'true') return;

      const text = document.createElement('span');
      text.className = 'dede-choose-text';
      text.textContent = chooseText;

      const gpoLabelContent = label.matches('.gpo-label')
        ? label.querySelector('.label-content')
        : null;

      if (gpoLabelContent) {
        gpoLabelContent.insertAdjacentElement('afterend', text);
      } else {
        label.append(text);
      }

      label.dataset.dedeChooseAdded = 'true';
    };

    const formatMoney = (value) => `${moneyFormatter.format(value)} TL`;

    const normalizeOptionName = (fieldLabel, value) => {
      let name = normalizeWhitespace(value)
        .replace(/\s*[—-]\s*Fiyata\s+dahil\s*$/i, '')
        .replace(/\s*\(\s*\+[^)]*\)\s*$/i, '');

      if (fieldLabel === 'Kabin Sistemi' && name === 'Eko Sistem') {
        name = 'Standart Duş Sistemi';
      }

      if (fieldLabel === 'Duş Armatür Seti' && name === 'Standart') {
        name = 'Standart Duş Seti';
      }

      if (fieldLabel === 'Duş Armatür Seti' && name === 'GROHE') {
        name = 'GROHE Duş Seti';
      }

      return name;
    };

    const getOptionPrice = (option) => {
      const value = Number.parseFloat(option.dataset.addonPrice || '0');
      return Number.isFinite(value) ? value : 0;
    };

    const updateSelectDisplay = (field) => {
      const selectWrap = field.querySelector(':scope > .gpo-select');
      const select = selectWrap?.querySelector('select');
      const fieldLabel = field.querySelector('.gpo-label .label-content')?.textContent.trim() || '';

      if (!selectWrap || !select) return;

      Array.from(select.options).forEach((option) => {
        if (!option.value) {
          option.dataset.dedeShortLabel = normalizeWhitespace(option.textContent);
          return;
        }

        const sourceName = option.getAttribute('original-value') || option.value || option.textContent;
        const shortName = normalizeOptionName(fieldLabel, sourceName);
        const price = getOptionPrice(option);
        const fullLabel = price > 0
          ? `${shortName} — +${formatMoney(price)}`
          : `${shortName} — ${includedText}`;

        option.dataset.dedeShortLabel = shortName;

        if (normalizeWhitespace(option.textContent) !== fullLabel) {
          option.textContent = fullLabel;
        }
      });

      let display = selectWrap.querySelector(':scope > .dede-select-display');

      if (!display) {
        display = document.createElement('span');
        display.className = 'dede-select-display';
        display.setAttribute('aria-hidden', 'true');
        selectWrap.append(display);
      }

      const refreshDisplay = () => {
        const selectedOption = select.options[select.selectedIndex];
        const shortLabel = selectedOption?.dataset.dedeShortLabel || normalizeWhitespace(selectedOption?.textContent || '');

        if (display.textContent !== shortLabel) {
          display.textContent = shortLabel;
        }
      };

      select.classList.add('dede-select-overlay-active');
      refreshDisplay();

      if (select.dataset.dedeDisplayBound !== 'true') {
        select.addEventListener('change', refreshDisplay);
        select.dataset.dedeDisplayBound = 'true';
      }
    };

    const hasChoiceLabel = (element) => {
      const label = element.querySelector(':scope > .gpo-label .label-content, :scope > .dede-label-group .gpo-label .label-content');
      return Boolean(label);
    };

    const getChoiceLabel = (field) => field
      .querySelector('.gpo-label .label-content')
      ?.textContent.trim() || '';

    const splitHelpText = (value) => value
      .replace(/\[\[AYIR\]\]/g, '\n')
      .replace(/([.!?])\s+(?=\S)/g, '$1\n')
      .split(/\n+/)
      .map((part) => part.trim())
      .filter(Boolean);

    const appendHelpParagraph = (block, text) => {
      const paragraph = document.createElement('p');
      const colonIndex = text.indexOf(':');

      if (colonIndex > 0 && colonIndex <= 80) {
        const heading = document.createElement('strong');
        heading.textContent = text.slice(0, colonIndex + 1);
        paragraph.append(heading, document.createTextNode(text.slice(colonIndex + 1)));
      } else {
        paragraph.textContent = text;
      }

      block.append(paragraph);
    };

    const renderHelpPanel = (panel, tooltipText) => {
      const signature = tooltipText;

      if (panel.dedeHelpSignature === signature) return;

      panel.replaceChildren();

      const block = document.createElement('div');
      block.className = 'dede-info-block';
      splitHelpText(tooltipText).forEach((part) => appendHelpParagraph(block, part));
      panel.append(block);

      panel.dedeHelpSignature = signature;
    };

    const closeOtherInfoPanels = (group, activeButton) => {
      group.querySelectorAll('.dede-info-button').forEach((button) => {
        if (button === activeButton) return;

        button.setAttribute('aria-expanded', 'false');
        const panel = group.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);

        if (panel) panel.hidden = true;
      });
    };

    const enhanceInfoField = (field, group, optionSetId) => {
      const fieldLabel = getChoiceLabel(field);

      const label = field.querySelector(':scope > .gpo-label, :scope > .dede-label-group > .gpo-label');

      if (!label) return;

      const originalTooltip = label.querySelector('.label-tooltip');
      const tooltipText = originalTooltip
        ?.querySelector('.label-tooltip__content')
        ?.textContent.trim() || '';

      if (originalTooltip) {
        originalTooltip.classList.add('dede-original-tooltip');
        originalTooltip.setAttribute('aria-hidden', 'true');
      }

      let labelGroup = field.querySelector(':scope > .dede-label-group');

      if (!labelGroup) {
        labelGroup = document.createElement('div');
        labelGroup.className = 'dede-label-group';
        label.before(labelGroup);
        labelGroup.append(label);
      }

      let infoButton = labelGroup.querySelector(':scope > .dede-info-button');
      let panel = field.querySelector(':scope > .dede-info-panel');

      if (!tooltipText) {
        infoButton?.remove();
        panel?.remove();
        field.classList.add('dede-gpo-choice-row');
        updateSelectDisplay(field);
        return;
      }

      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'dede-info-panel';
        panel.id = `dede-info-${optionSetId}-${field.dataset.elementId || fieldLabel}`.replace(/[^a-zA-Z0-9_-]/g, '-');
        panel.hidden = true;
        field.append(panel);
      }

      if (!infoButton) {
        infoButton = document.createElement('button');
        infoButton.type = 'button';
        infoButton.className = 'dede-info-button';
        infoButton.textContent = 'ⓘ';
        infoButton.setAttribute('aria-label', `${fieldLabel} hakkında bilgi`);
        infoButton.setAttribute('aria-expanded', 'false');
        labelGroup.append(infoButton);

        infoButton.addEventListener('click', () => {
          const willOpen = infoButton.getAttribute('aria-expanded') !== 'true';
          closeOtherInfoPanels(group, infoButton);
          infoButton.setAttribute('aria-expanded', String(willOpen));
          panel.hidden = !willOpen;
        });
      }

      infoButton.setAttribute('aria-controls', panel.id);
      renderHelpPanel(panel, tooltipText);

      field.classList.add('dede-gpo-choice-row');
      updateSelectDisplay(field);
    };

    const getSelectedAddonTotal = (app) => {
      let total = 0;

      app.querySelectorAll('select').forEach((select) => {
        const option = select.options[select.selectedIndex];
        total += option ? getOptionPrice(option) : 0;
      });

      app.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach((input) => {
        const value = Number.parseFloat(input.dataset.addonPrice || '0');
        total += Number.isFinite(value) ? value : 0;
      });

      return total;
    };

    const updateTotalSummary = (app) => {
      const totalContainer = app.querySelector(':scope > .gpo-total');
      const source = totalContainer?.querySelector('.gpo-total-text');

      if (!totalContainer || !source) return;

      source.classList.add('dede-total-source');

      let summary = totalContainer.querySelector(':scope > .dede-total-summary');

      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'dede-total-summary';
        summary.setAttribute('aria-live', 'polite');

        const label = document.createElement('span');
        label.textContent = extraTotalText;

        const value = document.createElement('strong');
        value.className = 'dede-total-value';

        summary.append(label, value);
        totalContainer.append(summary);
      }

      const total = getSelectedAddonTotal(app);
      const formatted = total > 0 ? `+${formatMoney(total)}` : '';
      const value = summary.querySelector('.dede-total-value');

      if (value.textContent !== formatted) value.textContent = formatted;

      summary.hidden = total <= 0;
      totalContainer.classList.toggle('dede-total-empty', total <= 0);
    };

    const openOptionsGroup = (group) => {
      const toggle = group.querySelector(':scope > .dede-options-toggle');
      const body = group.querySelector('.dede-options-body');

      if (!toggle || !body) return;

      toggle.setAttribute('aria-expanded', 'true');
      body.hidden = false;
    };

    const revealValidationErrors = (group) => {
      const body = group.querySelector('.dede-options-body');

      if (!body) return;

      const error = Array.from(body.querySelectorAll('.messages')).find((message) => message.textContent.trim());

      if (!error) {
        delete group.dataset.dedeErrorRevealed;
        return;
      }

      openOptionsGroup(group);

      if (group.dataset.dedeErrorRevealed === 'true') return;

      group.dataset.dedeErrorRevealed = 'true';
      const field = error.closest('.gpo-element');
      const control = field?.querySelector('select, input, textarea');

      field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      control?.focus({ preventScroll: true });
    };

    const enhanceGloboGroup = (group, app, groupIndex) => {
      const body = group.querySelector('.gpo-group__childs');

      if (!body) return;

      const choiceFields = Array.from(body.children).filter(hasChoiceLabel);

      if (choiceFields.length === 0) return;

      group.classList.add('dede-options-group');
      body.classList.add('dede-options-body');

      if (!body.id) {
        body.id = `dede-options-body-${app.dataset.optionSetId || 'product'}-${groupIndex}`;
      }

      let toggle = group.querySelector(':scope > .dede-options-toggle');

      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'dede-options-toggle';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-controls', body.id);

        const title = document.createElement('span');
        title.className = 'dede-options-title';
        title.textContent = optionsTitle;

        const subtitle = document.createElement('span');
        subtitle.className = 'dede-options-subtitle';
        subtitle.textContent = optionsSubtitle;

        const chevron = document.createElement('span');
        chevron.className = 'dede-options-chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '⌄';

        toggle.append(title, subtitle, chevron);
        const toggleAnchor = body.closest('.gpo-group__wrapper') || body;
        group.insertBefore(toggle, toggleAnchor);

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isOpen));
          body.hidden = isOpen;
        });
      }

      const optionSetId = `${app.dataset.optionSetId || 'product'}-${groupIndex}`;
      choiceFields.forEach((field) => enhanceInfoField(field, group, optionSetId));
      revealValidationErrors(group);
    };

    const enhanceOptions = () => {
      document.querySelectorAll('.gpo-container .dede-help-source').forEach((source) => {
        source.hidden = false;
        source.removeAttribute('aria-hidden');
        source.classList.remove('dede-help-source');
      });

      document
        .querySelectorAll('variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label')
        .forEach(addChooseText);

      document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((field) => {
        const select = field.querySelector(':scope > .select > .select__select');
        const isSingleOption = select?.options.length === 1;

        field.classList.add('dede-option-row');
        field.classList.toggle('dede-single-option', isSingleOption);

        if (!select) return;

        if (isSingleOption) {
          select.setAttribute('aria-disabled', 'true');
          select.tabIndex = -1;
          select.dataset.dedeSingleOption = 'true';
        } else if (select.dataset.dedeSingleOption === 'true') {
          select.removeAttribute('aria-disabled');
          select.removeAttribute('tabindex');
          delete select.dataset.dedeSingleOption;
        }
      });

      document.querySelectorAll('.gpo-container .gpo-app').forEach((app) => {
        app.querySelectorAll(':scope > .gpo-group').forEach((group, groupIndex) => {
          enhanceGloboGroup(group, app, groupIndex);
        });

        updateTotalSummary(app);

        if (app.dataset.dedeChangeBound !== 'true') {
          app.addEventListener('change', queueEnhancement);
          app.dataset.dedeChangeBound = 'true';
        }
      });

    };

    let updateQueued = false;

    const queueEnhancement = () => {
      if (updateQueued) return;

      updateQueued = true;
      requestAnimationFrame(() => {
        updateQueued = false;
        enhanceOptions();
      });
    };

    enhanceOptions();

    const observer = new MutationObserver(queueEnhancement);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dede-product-option-layout"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const marker = document.querySelector('[data-dede-product-option-layout]');

      if (!marker) return;

    const configuredChooseText = marker.dataset.chooseText?.trim();
    const chooseText = configuredChooseText === 'Seçiniz' ? 'Seçin' : configuredChooseText;
    const optionsTitle = marker.dataset.optionsTitle?.trim() || 'Ürün Seçenekleri';
    const optionsSubtitle = marker.dataset.optionsSubtitle?.trim() || 'Standart seçenekleri özelleştirin';
    const includedText = marker.dataset.includedText?.trim() || 'Fiyata Dahil';
    const extraTotalText = marker.dataset.extraTotalText?.trim() || 'Seçeneklerden eklenen tutar:';
    const moneyFormatter = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });

    const normalizeWhitespace = (value) => value.replace(/\s+/g, ' ').trim();

    const addChooseText = (label) => {
      if (!chooseText) return;

      const field = label.closest('.product-form__input');
      const select = field?.querySelector(':scope > .select > .select__select');
      const radioCount = field?.querySelectorAll('input[type="radio"]').length ?? 0;
      const optionCount = select?.options.length ?? radioCount;

      if (optionCount === 1) {
        label.querySelector(':scope > .dede-choose-text')?.remove();
        delete label.dataset.dedeChooseAdded;
        return;
      }

      if (label.dataset.dedeChooseAdded === 'true') return;

      const text = document.createElement('span');
      text.className = 'dede-choose-text';
      text.textContent = chooseText;

      const gpoLabelContent = label.matches('.gpo-label')
        ? label.querySelector('.label-content')
        : null;

      if (gpoLabelContent) {
        gpoLabelContent.insertAdjacentElement('afterend', text);
      } else {
        label.append(text);
      }

      label.dataset.dedeChooseAdded = 'true';
    };

    const formatMoney = (value) => `${moneyFormatter.format(value)} TL`;

    const getOptionName = (value) => normalizeWhitespace(value)
      .replace(/\s*[—-]\s*Fiyata\s+dahil\s*$/i, '')
      .replace(/\s*\(\s*\+[^)]*\)\s*$/i, '');

    const getOptionPrice = (option) => {
      const value = Number.parseFloat(option.dataset.addonPrice || '0');
      return Number.isFinite(value) ? value : 0;
    };

    const updateSelectDisplay = (field) => {
      const selectWrap = field.querySelector(':scope > .gpo-select');
      const select = selectWrap?.querySelector('select');

      if (!selectWrap || !select) return;

      Array.from(select.options).forEach((option) => {
        if (!option.value) {
          option.dataset.dedeShortLabel = normalizeWhitespace(option.textContent);
          return;
        }

        const sourceName = option.getAttribute('original-value') || option.value || option.textContent;
        const shortName = getOptionName(sourceName);
        const price = getOptionPrice(option);
        const fullLabel = price > 0
          ? `${shortName} — +${formatMoney(price)}`
          : `${shortName} — ${includedText}`;

        option.dataset.dedeShortLabel = shortName;

        if (normalizeWhitespace(option.textContent) !== fullLabel) {
          option.textContent = fullLabel;
        }
      });

      let display = selectWrap.querySelector(':scope > .dede-select-display');

      if (!display) {
        display = document.createElement('span');
        display.className = 'dede-select-display';
        display.setAttribute('aria-hidden', 'true');
        selectWrap.append(display);
      }

      const refreshDisplay = () => {
        const selectedOption = select.options[select.selectedIndex];
        const shortLabel = selectedOption?.dataset.dedeShortLabel || normalizeWhitespace(selectedOption?.textContent || '');

        if (display.textContent !== shortLabel) {
          display.textContent = shortLabel;
        }
      };

      select.classList.add('dede-select-overlay-active');
      refreshDisplay();

      if (select.dataset.dedeDisplayBound !== 'true') {
        select.addEventListener('change', refreshDisplay);
        select.dataset.dedeDisplayBound = 'true';
      }
    };

    const hasChoiceLabel = (element) => {
      const label = element.querySelector(':scope > .gpo-label .label-content, :scope > .dede-label-group .gpo-label .label-content');
      return Boolean(label);
    };

    const getChoiceLabel = (field) => field
      .querySelector('.gpo-label .label-content')
      ?.textContent.trim() || '';

    const splitHelpText = (value) => value
      .replace(/\[\[AYIR\]\]/g, '\n')
      .replace(/([.!?])\s+(?=\S)/g, '$1\n')
      .split(/\n+/)
      .map((part) => part.trim())
      .filter(Boolean);

    const appendHelpParagraph = (block, text) => {
      const paragraph = document.createElement('p');
      const colonIndex = text.indexOf(':');

      if (colonIndex > 0 && colonIndex <= 80) {
        const heading = document.createElement('strong');
        heading.textContent = text.slice(0, colonIndex + 1);
        paragraph.append(heading, document.createTextNode(text.slice(colonIndex + 1)));
      } else {
        paragraph.textContent = text;
      }

      block.append(paragraph);
    };

    const renderHelpPanel = (panel, tooltipText) => {
      const signature = tooltipText;

      if (panel.dedeHelpSignature === signature) return;

      panel.replaceChildren();

      const block = document.createElement('div');
      block.className = 'dede-info-block';
      splitHelpText(tooltipText).forEach((part) => appendHelpParagraph(block, part));
      panel.append(block);

      panel.dedeHelpSignature = signature;
    };

    const closeAllInfoPanels = (group) => {
      group.querySelectorAll('.dede-info-button').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
        const panel = group.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);

        if (panel) panel.hidden = true;
      });

      group.classList.remove('dede-general-info-open');
    };

    const enhanceInfoField = (field, group, optionSetId) => {
      const fieldLabel = getChoiceLabel(field);

      const label = field.querySelector(':scope > .gpo-label, :scope > .dede-label-group > .gpo-label');

      if (!label) return;

      const originalTooltip = label.querySelector('.label-tooltip');
      const tooltipText = originalTooltip
        ?.querySelector('.label-tooltip__content')
        ?.textContent.trim() || '';

      if (originalTooltip) {
        originalTooltip.classList.add('dede-original-tooltip');
        originalTooltip.setAttribute('aria-hidden', 'true');
      }

      let labelGroup = field.querySelector(':scope > .dede-label-group');

      if (!labelGroup) {
        labelGroup = document.createElement('div');
        labelGroup.className = 'dede-label-group';
        label.before(labelGroup);
        labelGroup.append(label);
      }

      let infoButton = labelGroup.querySelector(':scope > .dede-info-button');
      let panel = field.querySelector(':scope > .dede-info-panel');

      if (!tooltipText) {
        infoButton?.remove();
        panel?.remove();
        field.classList.add('dede-gpo-choice-row');
        updateSelectDisplay(field);
        return;
      }

      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'dede-info-panel';
        panel.id = `dede-info-${optionSetId}-${field.dataset.elementId || fieldLabel}`.replace(/[^a-zA-Z0-9_-]/g, '-');
        panel.hidden = true;
        field.append(panel);
      }

      if (!infoButton) {
        infoButton = document.createElement('button');
        infoButton.type = 'button';
        infoButton.className = 'dede-info-button';
        infoButton.textContent = 'ⓘ';
        infoButton.setAttribute('aria-label', `${fieldLabel} hakkında bilgi`);
        infoButton.setAttribute('aria-expanded', 'false');
        labelGroup.append(infoButton);

        infoButton.addEventListener('click', () => {
          const willOpen = infoButton.getAttribute('aria-expanded') !== 'true';
          closeAllInfoPanels(group);

          if (willOpen) {
            infoButton.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            group.classList.add('dede-general-info-open');
          }
        });
      }

      infoButton.setAttribute('aria-controls', panel.id);
      renderHelpPanel(panel, tooltipText);

      field.classList.add('dede-gpo-choice-row');
      updateSelectDisplay(field);
    };

    const getSelectedAddonTotal = (app) => {
      let total = 0;

      app.querySelectorAll('select').forEach((select) => {
        const option = select.options[select.selectedIndex];
        total += option ? getOptionPrice(option) : 0;
      });

      app.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach((input) => {
        const value = Number.parseFloat(input.dataset.addonPrice || '0');
        total += Number.isFinite(value) ? value : 0;
      });

      return total;
    };

    const updateTotalSummary = (app) => {
      const totalContainer = app.querySelector(':scope > .gpo-total');
      const source = totalContainer?.querySelector('.gpo-total-text');

      if (!totalContainer || !source) return;

      source.classList.add('dede-total-source');

      let summary = totalContainer.querySelector(':scope > .dede-total-summary');

      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'dede-total-summary';
        summary.setAttribute('aria-live', 'polite');

        const label = document.createElement('span');
        label.textContent = extraTotalText;

        const value = document.createElement('strong');
        value.className = 'dede-total-value';

        summary.append(label, value);
        totalContainer.append(summary);
      }

      const total = getSelectedAddonTotal(app);
      const formatted = total > 0 ? `+${formatMoney(total)}` : '';
      const value = summary.querySelector('.dede-total-value');

      if (value.textContent !== formatted) value.textContent = formatted;

      summary.hidden = total <= 0;
      totalContainer.classList.toggle('dede-total-empty', total <= 0);
    };

    const openOptionsGroup = (group) => {
      const toggle = group.querySelector(':scope > .dede-options-toggle');
      const body = group.querySelector('.dede-options-body');

      if (!toggle || !body) return;

      toggle.setAttribute('aria-expanded', 'true');
      body.hidden = false;
    };

    const revealValidationErrors = (group) => {
      const body = group.querySelector('.dede-options-body');

      if (!body) return;

      const error = Array.from(body.querySelectorAll('.messages')).find((message) => message.textContent.trim());

      if (!error) {
        delete group.dataset.dedeErrorRevealed;
        return;
      }

      openOptionsGroup(group);

      if (group.dataset.dedeErrorRevealed === 'true') return;

      group.dataset.dedeErrorRevealed = 'true';
      const field = error.closest('.gpo-element');
      const control = field?.querySelector('select, input, textarea');

      field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      control?.focus({ preventScroll: true });
    };

    const activateOptionDescription = (group, field) => {
      const fieldId = field.dataset.elementId || field.dataset.dedeDescriptionIndex;

      if (!fieldId) return;

      group.dataset.dedeActiveDescriptionFor = fieldId;
      group.classList.add('dede-exclusive-descriptions');

      group.querySelectorAll('.dede-option-description').forEach((row) => {
        row.classList.toggle('dede-option-description-active', row.dataset.dedeDescriptionFor === fieldId);
      });
    };

    const markOptionDescriptions = (group, body, choiceFields) => {
      const choiceSet = new Set(choiceFields);

      choiceFields.forEach((field, fieldIndex) => {
        field.dataset.dedeDescriptionIndex = String(fieldIndex);
      });

      if (!group.dataset.dedeActiveDescriptionFor) {
        const initialField = choiceFields.find((field) => {
          const select = field.querySelector('select');

          if (select) return Boolean(select.value);

          return Boolean(field.querySelector('input:checked'));
        }) || choiceFields[0];

        group.dataset.dedeActiveDescriptionFor = initialField.dataset.elementId
          || initialField.dataset.dedeDescriptionIndex;
      }

      group.classList.add('dede-exclusive-descriptions');

      body.querySelectorAll(':scope > .dede-option-description').forEach((row) => {
        row.classList.remove('dede-option-description');
        row.classList.remove('dede-option-description-active');
        delete row.dataset.dedeDescriptionFor;
      });

      choiceFields.forEach((field, fieldIndex) => {
        let row = field.nextElementSibling;
        const fieldId = field.dataset.elementId || field.dataset.dedeDescriptionIndex || String(fieldIndex);

        while (row && !choiceSet.has(row)) {
          if (row.querySelector(':scope > .gpo-paragraph')) {
            row.classList.add('dede-option-description');
            row.classList.toggle(
              'dede-option-description-active',
              group.dataset.dedeActiveDescriptionFor === fieldId
            );
            row.dataset.dedeDescriptionFor = fieldId;
          }

          row = row.nextElementSibling;
        }
      });
    };

    const enhanceGloboGroup = (group, app, groupIndex) => {
      const body = group.querySelector('.gpo-group__childs');

      if (!body) return;

      const choiceFields = Array.from(body.children).filter(hasChoiceLabel);

      if (choiceFields.length === 0) return;

      group.classList.add('dede-options-group');
      body.classList.add('dede-options-body');

      if (!body.id) {
        body.id = `dede-options-body-${app.dataset.optionSetId || 'product'}-${groupIndex}`;
      }

      let toggle = group.querySelector(':scope > .dede-options-toggle');

      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'dede-options-toggle';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-controls', body.id);

        const title = document.createElement('span');
        title.className = 'dede-options-title';
        title.textContent = optionsTitle;

        const subtitle = document.createElement('span');
        subtitle.className = 'dede-options-subtitle';
        subtitle.textContent = optionsSubtitle;

        const chevron = document.createElement('span');
        chevron.className = 'dede-options-chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '⌄';

        toggle.append(title, subtitle, chevron);
        const toggleAnchor = body.closest('.gpo-group__wrapper') || body;
        group.insertBefore(toggle, toggleAnchor);

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isOpen));
          body.hidden = isOpen;
        });
      }

      const optionSetId = `${app.dataset.optionSetId || 'product'}-${groupIndex}`;
      markOptionDescriptions(group, body, choiceFields);
      choiceFields.forEach((field) => enhanceInfoField(field, group, optionSetId));
      revealValidationErrors(group);
    };

    const enhanceOptions = () => {
      document.querySelectorAll('.gpo-container .dede-help-source').forEach((source) => {
        source.hidden = false;
        source.removeAttribute('aria-hidden');
        source.classList.remove('dede-help-source');
      });

      document
        .querySelectorAll('variant-selects .product-form__input > .form__label, variant-radios .product-form__input > .form__label')
        .forEach(addChooseText);

      document.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((field) => {
        const select = field.querySelector(':scope > .select > .select__select');
        const isSingleOption = select?.options.length === 1;

        field.classList.add('dede-option-row');
        field.classList.toggle('dede-single-option', isSingleOption);

        if (!select) return;

        if (isSingleOption) {
          select.setAttribute('aria-disabled', 'true');
          select.tabIndex = -1;
          select.dataset.dedeSingleOption = 'true';
        } else if (select.dataset.dedeSingleOption === 'true') {
          select.removeAttribute('aria-disabled');
          select.removeAttribute('tabindex');
          delete select.dataset.dedeSingleOption;
        }
      });

      document.querySelectorAll('.gpo-container .gpo-app').forEach((app) => {
        app.querySelectorAll(':scope > .gpo-group').forEach((group, groupIndex) => {
          enhanceGloboGroup(group, app, groupIndex);
        });

        updateTotalSummary(app);

        if (app.dataset.dedeChangeBound !== 'true') {
          app.addEventListener('change', (event) => {
            const field = event.target.closest('.dede-gpo-choice-row');
            const group = field?.closest('.dede-options-group');

            if (group && field) {
              closeAllInfoPanels(group);
              activateOptionDescription(group, field);
            }

            queueEnhancement();
          });

          const handleOptionInteraction = (event) => {
            if (event.target.closest('.dede-info-button')) return;

            const field = event.target.closest('.dede-gpo-choice-row');
            const group = field?.closest('.dede-options-group');

            if (!group || !field) return;

            closeAllInfoPanels(group);
            activateOptionDescription(group, field);
          };

          app.addEventListener('click', handleOptionInteraction);
          app.addEventListener('focusin', handleOptionInteraction);
          app.dataset.dedeChangeBound = 'true';
        }
      });

    };

    let updateQueued = false;

    const queueEnhancement = () => {
      if (updateQueued) return;

      updateQueued = true;
      requestAnimationFrame(() => {
        updateQueued = false;
        enhanceOptions();
      });
    };

    enhanceOptions();

    const observer = new MutationObserver(queueEnhancement);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

      document.addEventListener('shopify:section:load', queueEnhancement);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
